export enum AppType {
  ANDROID_IOS = 'Android/IOS',
  PWA = 'PWA'
}

export interface FirebaseConfig {
  type: string;
  project_id: string;
  private_key_id: string;
  private_key: string;
  client_email: string;
  client_id: string;
  auth_uri: string;
  token_uri: string;
  auth_provider_x509_cert_url: string;
  client_x509_cert_url: string;
  universe_domain: string;
  bundle: string;
  oc: string;
}

export interface Application {
  id: number;
  type: AppType;
  name: string;
  bundle_id: string;
  firebase_config: FirebaseConfig;
  user_id: number;
  created_at: string;
  updated_at: string;
  auto_created: boolean;
  access_verified: boolean;
  access_checked_at?: string | null;
  owner?: unknown;
  user_count?: number;
  active_users?: number;
  send_install_data: boolean;
}

export interface NullString {
  String: string;
  Valid: boolean;
}

export type NullableString = string | NullString | null | undefined;

export interface AppUser {
  id: number;
  app_id: number;
  bundle_id: string;
  user_external_id?: NullableString;
  appsflyer_id?: NullableString;
  os: string;
  locale: string;
  country?: NullableString;
  push_token: string;
  install_date: string;
  source_app_name?: NullableString;
  has_deposit: boolean;
  deposit_date?: string;
  has_registration: boolean;
  registration_date?: string;
  offer?: NullableString;
  buyer_id?: NullableString;
  failed_push_attempts: number;
  last_failed_attempt?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  application?: Application;
}

export interface AppUserFilter {
  app_id?: number;
  has_registration?: boolean;
  has_deposit?: boolean;
  locale?: string;
  country?: string;
  os?: string;
  offer?: string;
  date_from?: string;
  date_to?: string;
  search?: string;
  is_active?: boolean;
  limit?: number;
  offset?: number;
  buyer_id?: string;
}

export interface ApplicationCopyRequest {
  name: string;
  bundle_id: string;
  firebase_config?: FirebaseConfig;
}

export interface AppUserStats {
  total_users: number;
  active_users: number;
  deleted_users: number;
  with_registration: number;
  with_deposit: number;
  by_os: Record<string, number>;
  by_locale: Record<string, number>;
  by_country: Record<string, number>;
  by_offer: Record<string, number>;
  installs_by_date: Record<string, number>;
}

export interface ApplicationLookup {
  id: number;
  name: string;
  bundle_id: string;
  type: AppType;
}

export interface ApplicationCreateRequest {
  type: AppType;
  name: string;
  bundle_id: string;
  firebase_config: FirebaseConfig;
  send_install_data: boolean;
}

export interface ApplicationUpdateRequest {
  name?: string;
  firebase_config?: FirebaseConfig;
  send_install_data?: boolean;
}

export interface ApplicationAccessRequest {
  viewer_id: number;
  app_id: number;
}

export const getNullableString = (value: NullableString): string | null => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string') return value || null;
  if (typeof value === 'object' && 'String' in value && 'Valid' in value) {
    return value.Valid ? value.String : null;
  }
  return null;
};